export enum FiItemsListType {
    Unknown = -1,
    Documents,
    ChecklistSchedules,
    ChecklistsV2,
    BalooSyncLog,
    AgreementViewAccepted,
    SystemNotificationsForms,
    SystemNotificationsCheckpointAnswers,
    SystemNotificationsChecklists,
    SystemNotificationsAutosaved,
    Translations,
    SystemNotificationsTasks,
    UserAccessRequest,
    Users,
    Clusters,
    Areas,
    Units,
    Colleagues,
    UnitColleagues,
    HistoryList,
    OtherSettingsList,
    RolesList,
    ChecklistReportOpenChecklistsDeviationsTable,
    ChecklistReportOpenChecklistsTable,
    TagList,
    SiteMapList,
    ForumListData,
    ForumPostListData,
    SMS,
    MediaBank,
    PkImportLog,
    BusinessAreaList,
    Statistics,
    InsertMedia,
    FormReports,
    ReportViewCheckpointsOnUnit,
    FormListData,
    FormReportListData,
    ChecklistReportDetailsUnitsTable,
    ChecklistReportDetailsCheckpointsTable,
    ChecklistReportDeviationsTable,
    ChecklistReportDeviationDetailsTable,
    ChecklistReportHistoryChecklistsTable,
    ChecklistReportHistoryUnitsTable,
    ChecklistReportDetailsUnitAnswerDetailsTable,
    ChecklistV2Templates,
    ChecklistV2Audits,
    ChecklistV2AuditsPerUnit,
    HistoryChecklistDetailedAnswers,
    SystemNotificationsChecklists2,
    ChecklistV2AuditRecentActivity,
    ChecklistV2RecentActivity,
    TaskList,
    TaskV2List,
    ChecklistsV2Attachments,
    TaskV2ReportWidget,
    ArchivedTaskListData,
    LoginReminderLog,
    TodoListItems,
    OnboardingListItems,
    QuizListItems,
    OnboardingActive,
    OnboardingReportRecentActivity,
    OnboardingReportCompletion,
    OnboardingReportLocations,
    OnboardingReportParticipants,
    OnboardingSynchronized,
    OnboardingAssigneesList,
    OnboardingMasterUserAssigneesList,
}
